import { render, staticRenderFns } from "./CreateGoodsAttr.vue?vue&type=template&id=6423fb24&scoped=true"
import script from "./CreateGoodsAttr.vue?vue&type=script&lang=js"
export * from "./CreateGoodsAttr.vue?vue&type=script&lang=js"
import style0 from "./CreateGoodsAttr.vue?vue&type=style&index=0&id=6423fb24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6423fb24",
  null
  
)

export default component.exports